import React from 'react'
import { useTranslation } from 'react-i18next'

const SUPPORT_EMAIL = 'support@paytrie.com'

const CorporateSupportLineComponent = () => {
  const { t } = useTranslation()

  return (
    <p className="text-base" data-testid="text-corporate-support">
      {t('corporateSupport.prompt')}{' '}
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className="underline"
        data-testid="link-corporate-support"
      >
        {SUPPORT_EMAIL}
      </a>
      .
    </p>
  )
}

export const CorporateSupportLine = React.memo(CorporateSupportLineComponent)
